export default __webpack_public_path__ + "static/media/done.fe95e484.wav";